<template>
  <div>
    <template>
      <h6 class="heading-small text-muted mb-3">ข้อมูลทั่วไป ({{ (data.member_type == 'person') ? 'บุคคลธรรมดา' : (data.member_type == 'passport') ? 'พาสปอร์ต' : 'นิติบุคคล' }})</h6>
      <div class="row">
        <div class="col-lg-6">
          <label>คำนำหน้า : </label>
          <div class="form-group">
            <v-select
              :class="[
                { 'is-invalid bd-danger': submit && $v.data.name_title.$error },
                'w-100',
              ]"
              :label="data.showNameTitle"
              :options="listNameTitle"
              v-model="data.name_title"
            ></v-select>
            <!-- vuelidate -->
            <label
              v-if="submit && !$v.data.name_title.required"
              class="invalid-feedback d-block"
              >กรุณาเลือกคำนำหน้า</label
            >
          </div>
        </div>
        <div class="col-lg-6">
          <label> {{ (data.member_type == 'person' || data.member_type == 'passport') ? 'ชื่อ-นามสกุล' : 'ชื่อบริษัท' }}</label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.name.$error }"
              :placeholder="(data.member_type == 'person' || data.member_type == 'passport') ? 'ชื่อ-นามสกุล' : 'ชื่อบริษัท'"
              v-model="data.name"
            />
            <!-- vuelidate -->
            <label class="error invalid-feedback" v-if="!$v.data.name.minLength"
              >กรุณากรอก"ชื่อ-นามสกุล"อย่างน้อย
              {{ $v.data.name.$params.minLength.min }} ตัวอักษร</label
            >
            <label v-if="submit && !$v.data.name.required" class="invalid-feedback"
              >กรุณากรอกชื่อ-นามสกุล</label
            >
          </div>
        </div>
        <div class="col-lg-6">
          <label>{{ (data.member_type == 'person') ? 'เลขบัตรประชาชน' : (data.member_type == 'passport') ? 'หมายเลขพาสปอร์ต' : 'เลขประจำตัวผู้เสียภาษี' }}</label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.tax_id.$error }"
              :placeholder="(data.member_type == 'person') ? 'เลขบัตรประชาชน' : (data.member_type == 'passport') ? 'หมายเลขพาสปอร์ต' : 'เลขประจำตัวผู้เสียภาษี'"
              v-model="data.tax_id"
              @change="checkTax"
            />
            <!-- vuelidate -->
            <label class="error invalid-feedback" v-if="!$v.data.tax_id.minLength"
              >กรุณากรอก"เลขบัตรประชาชน"อย่างน้อย
              {{ $v.data.tax_id.$params.minLength.min }} ตัวเลข</label
            >
            <label class="error invalid-feedback" v-if="!$v.data.tax_id.maxLength"
              >กรุณากรอก"เลขบัตรประชาชน"ไม่เกิน
              {{ $v.data.tax_id.$params.maxLength.max }} ตัวเลข</label
            >
            <label v-if="submit && !$v.data.tax_id.required" class="invalid-feedback"
              >กรุณากรอกเลขบัตรประชาชน</label
            >
            <small
                  v-if="data.errorTax"
                  class="text-danger"
                >กรุณากรอกหมายเลขบัตรประชนชนให้ถูกต้อง</small>
          </div>
        </div>
        <div class="col-lg-6" v-if="data.member_type == 'person'">
          <label>เลขหลังบัตรประชาชน : </label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.laser_code.$error }"
              placeholder="เลขหลังบัตรประชาชน"
              v-model="data.laser_code"
            />
            <!-- vuelidate -->
            <label
              v-if="submit && !$v.data.laser_code.required"
              class="invalid-feedback"
              >กรุณากรอกเลขหลังบัตรประชาชน</label
            >
          </div>
        </div>
        <div class="col-lg-6" v-if="data.member_type == 'person' || data.member_type == 'passport'">
          <label>วันเกิด : </label>
          <div class="form-group">
            <input
              type="date"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.date_birthday.$error }"
              placeholder="วันเกิด"
              v-model="data.date_birthday"
            />
            <!-- vuelidate -->
            <label
              v-if="submit && !$v.data.date_birthday.required"
              class="invalid-feedback"
              >กรุณาเลือกวันเกิด</label
            >
          </div>
        </div>
        <div class="col-lg-6" v-if="data.member_type == 'person' || data.member_type == 'passport'">
          <label>วันที่บัตรหมดอายุ : </label>
          <div class="form-group">
            <input
              type="date"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.date_expiry.$error }"
              placeholder="วันที่บัตรหมดอายุ"
              v-model="data.date_expiry"
            />
            <!-- vuelidate -->
            <label
              v-if="submit && !$v.data.date_expiry.required"
              class="invalid-feedback"
              >กรุณาเลือกวันที่บัตรหมดอายุ</label
            >
          </div>
        </div>
        <div class="col-lg-6">
          <label>เบอร์โทรศัพท์ : </label>
          <div class="form-group">
            <input
              type="number"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.tel.$error }"
              placeholder="เบอร์โทรศัพท์"
              v-model="data.tel"
            />
            <!-- vuelidate -->
            <label v-if="submit && !$v.data.tel.required" class="invalid-feedback"
              >กรุณากรอกเบอร์โทรศัพท์</label
            >
            <label class="error invalid-feedback" v-if="!$v.data.tel.minLength"
              >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย
              {{ $v.data.tel.$params.minLength.min }}ตัวเลข</label
            >
          </div>
        </div>
        <div class="col-lg-6">
          <label>{{ (data.member_type == 'person') ? 'ที่อยู่ (ตามบัตรประชาชน) :' : (data.member_type == 'passport') ? 'ที่อยู่ (ในประเทศไทย)' : 'ที่อยู่จดทะเบียน (ตามภพ.20 ถ้ามี)'}} </label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submit && $v.data.address.$error }"
              placeholder="ที่อยู่ (ตามบัตรประชาชน)"
              v-model="data.address"
            />
            <!-- vuelidate -->
            <label class="error invalid-feedback" v-if="!$v.data.address.minLength"
              >กรุณากรอก"ที่อยู่"อย่างน้อย
              {{ $v.data.address.$params.minLength.min }} ตัวอักษร</label
            >
            <label
              v-if="submit && !$v.data.address.required"
              class="invalid-feedback"
              >กรุณากรอกที่อยู่</label
            >
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label floater>
              <small class="text-danger">*</small> ตำบล/แขวง
            </label>
            <AutocompletesAddress
              :queryInput="data.state"
              :adsTypes="'sub-district'"
              :class="{ 'is-invalid': submit && $v.data.state.$error }"
              @input="data.state = $event.target.value"
              @select:item="onSubmitAddress($event)"
            >
            </AutocompletesAddress>
            <div v-if="submit && !$v.data.state.required" class="invalid-th-address">
              กรุณากรอกตำบล/แขวง
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label floater>
              <small class="text-danger">*</small> อำเภอ/เขต
            </label>
            <AutocompletesAddress
              :queryInput="data.district"
              :adsTypes="'district'"
              :class="{ 'is-invalid': submit && $v.data.district.$error }"
              @input="data.district = $event.target.value"
              @select:item="onSubmitAddress($event)"
            >
            </AutocompletesAddress>
            <div
              v-if="submit && !$v.data.district.required"
              class="invalid-th-address"
            >
              กรุณากรอกอำเภอ/เขต
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label floater>
              <small class="text-danger">*</small> จังหวัด
            </label>
            <AutocompletesAddress
              :queryInput="data.province"
              :adsTypes="'province'"
              :class="{ 'is-invalid': submit && $v.data.province.$error }"
              @input="data.province = $event.target.value"
              @select:item="onSubmitAddress($event)"
            >
            </AutocompletesAddress>
            <div
              v-if="submit && !$v.data.province.required"
              class="invalid-th-address"
            >
              กรุณากรอกจังหวัด
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label floater>
              <small class="text-danger">*</small> รหัสไปรษณีย์
            </label>
            <AutocompletesAddress
              :queryInput="data.postcode"
              :adsTypes="'postcode'"
              :class="{ 'is-invalid': submit && $v.data.postcode.$error }"
              @input="data.postcode = $event.target.value"
              @select:item="onSubmitAddress($event)"
            >
            </AutocompletesAddress>
            <div
              v-if="submit && !$v.data.postcode.required"
              class="invalid-th-address"
            >
              กรุณากรอกรหัสไปรษณีย์
            </div>
            <div
              class="error invalid-th-address"
              v-if="submit && !$v.data.postcode.minLength"
            >
              กรุณากรอก"รหัสไปรษณีย์"
              {{ $v.data.postcode.$params.minLength.min }} หลัก
            </div>
            <div
              class="error invalid-th-address"
              v-if="submit && !$v.data.postcode.maxLength"
            >
              กรุณากรอก"รหัสไปรษณีย์"
              {{ $v.data.postcode.$params.maxLength.max }} หลัก
            </div>
            <div
              class="error invalid-th-address"
              v-if="submit && !$v.data.postcode.numeric"
            >
              กรุณากรอกเฉพาะตัวเลข
            </div>
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <h6 class="heading-small text-muted mb-3">ข้อมูลรูปภาพ</h6>
        <div class="row">
            <div class="col-lg-6" v-for="(image, index) in images" :key="index">
                <div class="form-group">
                    <label>
                        {{ image.lable }}
                    </label>
                    <b-form-file
                        :state="validateImages(index)"
                        accept=".jpg, .png"
                        placeholder="เลือกรูปภาพ"
                        @change="uploadImage(index, $event)"
                        v-model="image.file"
                    ></b-form-file>
                    <div class="text-center pt-2" v-if="image.preview">
                    <img
                        class="image-hover py-2"
                        :src="image.preview"
                        alt="image_card_front"
                        width="250"
                        height="200"
                        @click="$emit('showModalImages',image.preview, image.name)"
                    />
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
    </template>
  </div>
</template>

<script>
import swapLang from "@/plugins/swapLang.js";
import Compressor from 'compressorjs'
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";

export default {
    name:"FormIdentity",
    components:{
        AutocompletesAddress,
    },
    props: {
        submit: Boolean,
        data: Object,
        images: Array,
        listNameTitle: Array,
    },
    data(){
      return{
      }
    },
    validations(){
      return this.rule
    },
    methods:{
        validateImages( index ){
            let res = null
            if( this.submit && this.$v.images.$each && this.$v.images.$each[index].file.$error ){
                res = false
            }else if( this.$v.images[index] && this.$v.images[index].$error ){
                res = false
            }
            else{
                res = null
            }
            return res
        },
        checkTax(){
         this.data.tax_id = this.swapTaxt(this.data.tax_id);
        },
        swapTaxt(text){
            let swap = text.split('')
            let scanTaxt = '';
            swap.forEach(value =>{
            if(swapLang[value]){
                scanTaxt += swapLang[value]
            }else{
                scanTaxt += value
            }
            });
            return scanTaxt;
        },
        onSubmitAddress( ads ){
            Object.keys(ads).forEach( key =>{
                if( key == 'sub-district'){
                    this.data['state'] = ads['sub-district']
                }else{
                   this.data[key] = String(ads[key])
                }
            })
        },
        uploadImage(index,e) {
            if (e.target.files.length < 1) return false;
            const image = e.target.files[0]
            let SELF = this
            new Compressor(image, {
              quality: 0.6,
              maxHeight: 1024,
              maxHeight: 1024,
                success(result) {
                  const reader = new FileReader();
                  reader.readAsDataURL(result)
                  reader.onload = e => {
                    SELF.$set(SELF.images[index], 'preview' , e.target.result)
                  }
                }
            })
        },
    },
    computed:{
      rule(){
        let res = {
          data:{
            name_title: { required },
            name: { required, minLength: minLength(3) },
            address: { required, minLength: minLength(5) },
            state: { required },
            district: { required },
            province: { required },
            postcode: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) },
            tel: { required, numeric, minLength: minLength(9) },
            tax_id: { required, minLength: minLength(13), maxLength: maxLength(13) },
            laser_code: { required },
            date_birthday: { required },
            date_expiry: { required },
          },
          images: {
            $each: {
              file: { required }
            }
          }
        }
        if( this.data.member_type == 'company' ){
          res.data.date_birthday = {}
          res.data.laser_code = {}
          res.data.date_expiry = {}
          res.images = {}
          res.images[0] = { file:{required} }
        }
        if( this.data.member_type == 'passport' ){
          res.data.laser_code = {}
          res.data.tax_id = { required, minLength: minLength(7), maxLength: maxLength(30) },
          res.images = {}
          res.images[0] = { file:{required} }
          res.images[1] = { file:{required} }
        }
        return res
      },
    }
}
</script>